export default "__VITE_ASSET__CPry8X$c__"